<h3 class="title mt-5">
  {{ "Counter of Our Work" | translate }}
</h3>
<div class="row text-center my-5 align-items-center">
  <div class="col p-0">
    <img src="../../../assets/icon/counter-cv.png" />
    <p class="name">{{ "Resumes" | translate }}</p>
    <h4 class="number">1,897</h4>
  </div>
  <div class="line col-auto"></div>

  <div class="col">
    <img src="../../../assets/icon/counter-linkedin.png" />
    <p class="name">{{ "LinkedIn Profiles" | translate }}</p>
    <h4 class="number" class="number">334</h4>
  </div>
  <div class="line col-auto"></div>
  <div class="col p-0">
    <img src="../../../assets/icon/counter-coverletter.png" />
    <p class="name">{{ "Cover Letters" | translate }}</p>
    <h4 class="number">56</h4>
  </div>
</div>
